"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyDocument = void 0;
function makeEmptyDocument() {
    return {
        id: '',
        name: '',
        content: '',
        mime: '',
    };
}
exports.makeEmptyDocument = makeEmptyDocument;
//# sourceMappingURL=Document.js.map